import { InfinitySpin } from "react-loader-spinner";

export interface LoadingProps {}

export function Loading(props: LoadingProps) {
  return (
    <div className="absolute">
      <div className=""></div>
      <div className="absolute top-1/3 left-1/2 z-10">
        <InfinitySpin width="200" color="var(--color-mk-primary-bright)" />
      </div>
    </div>
  );
}
